import { List } from 'immutable';
import { energyName } from '../Energy';

/**
 * Badges for an active Pokémon whose Weakness or Resistance an attack changed (Conversion 1 and 2): the server sends
 * the ones that count now, and the card has the printed ones.
 *
 * @param {Map} activePokemon with `weakness`, `resistance` and its `card`
 * @returns {List<string>} like "Weak to Fighting", "Resists Fire"
 */
export function conversionBadges(activePokemon) {
  const card = activePokemon.get('card');
  const badges = [];

  if (activePokemon.get('weakness') && activePokemon.get('weakness') !== card.get('weakness_energy_id')) {
    badges.push(`Weak to ${energyName(activePokemon.get('weakness'))}`);
  }
  if (activePokemon.get('resistance') && activePokemon.get('resistance') !== card.get('resistance_energy_id')) {
    badges.push(`Resists ${energyName(activePokemon.get('resistance'))}`);
  }

  return List(badges);
}
